(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-email-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lf-email-popup')) {
    customElements.define('lf-email-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.key = 'lf-signup-dismissed-v1';
        this.querySelector('[data-lf-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-lf-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => {
          try { sessionStorage.setItem(this.key, '1'); } catch {}
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        });
        this.dialog.addEventListener('click', (event) => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        });
        if (this.querySelector('[data-lf-success], [data-lf-error]')) {
          this.open();
          if (this.querySelector('[data-lf-success]')) {
            try { sessionStorage.setItem(this.key, '1'); } catch {}
          }
          return;
        }
        let dismissed = false;
        try { dismissed = sessionStorage.getItem(this.key) === '1'; } catch {}
        if (!dismissed) this.timer = setTimeout(() => this.tryOpen(), Number(this.dataset.delay || 25) * 1000);
      }
      tryOpen() {
        const visible = element => element.getClientRects().length > 0;
        const blocked = document.hidden || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '') || [...document.querySelectorAll('[role="alertdialog"], dialog[open], details[open]')].some(visible);
        if (blocked) { this.timer = setTimeout(() => this.tryOpen(), 5000); return; }
        this.open();
      }
      open() {
        clearTimeout(this.timer);
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        this.querySelector('[data-lf-success], [data-lf-close]').focus({ preventScroll: true });
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('lf-newsletter-popup')) {
    class LfNewsletterPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.formState = this.querySelector('[data-form-success]');
        this.storageKey = 'lf-newsletter-popup-dismissed';
        this.onScroll = this.onScroll.bind(this);
        this.onSectionSelect = this.onSectionSelect.bind(this);

        if (!this.dialog) return;

        this.querySelectorAll('[data-lf-popup-close]').forEach((button) => {
          button.addEventListener('click', () => this.dismiss());
        });

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dismiss();
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dismiss();
        });

        document.addEventListener('shopify:section:select', this.onSectionSelect);

        const hasFeedback =
          this.formState?.dataset.formSuccess === 'true' || this.formState?.dataset.formError === 'true';
        const designMode = window.Shopify && window.Shopify.designMode;

        if (hasFeedback || designMode) {
          window.setTimeout(() => this.open(), 250);
          if (this.formState?.dataset.formSuccess === 'true') this.rememberDismissal();
          return;
        }

        if (this.wasRecentlyDismissed()) return;

        const delay = Number(this.dataset.delayMs) || 12000;
        this.openTimer = window.setTimeout(() => this.open(), delay);
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      disconnectedCallback() {
        window.clearTimeout(this.openTimer);
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
      }

      onSectionSelect(event) {
        if (event.detail.sectionId === this.id.replace('LfNewsletterPopup-', '')) this.open();
      }

      onScroll() {
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollableHeight <= 0) return;

        const progress = (window.scrollY / scrollableHeight) * 100;
        if (progress >= Number(this.dataset.scrollTrigger)) this.open();
      }

      open() {
        if (this.dialog.open) return;

        window.clearTimeout(this.openTimer);
        window.removeEventListener('scroll', this.onScroll);

        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      }

      dismiss() {
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
        this.rememberDismissal();
      }

      wasRecentlyDismissed() {
        try {
          const dismissedAt = Number(window.localStorage.getItem(this.storageKey));
          const frequencyMs = Number(this.dataset.frequencyDays) * 24 * 60 * 60 * 1000;
          return dismissedAt > 0 && Date.now() - dismissedAt < frequencyMs;
        } catch (error) {
          return false;
        }
      }

      rememberDismissal() {
        try {
          window.localStorage.setItem(this.storageKey, Date.now().toString());
        } catch (error) {
          // Storage may be unavailable in privacy-focused browsing modes.
        }
      }
    }

    customElements.define('lf-newsletter-popup', LfNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const normalizeBundlePunctuation = () => {
    document
      .querySelectorAll('.moonbundle-subtitle, .moonbundle-option-subtitle')
      .forEach((element) => {
        if (element.textContent.includes('—')) {
          element.textContent = element.textContent.replaceAll(' — ', ' : ').replaceAll('—', ':');
        }
      });
  };

  normalizeBundlePunctuation();

  const bundleObserver = new MutationObserver(normalizeBundlePunctuation);
  bundleObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  window.setTimeout(() => bundleObserver.disconnect(), 15000);

  } catch(e) { console.error(e); }
})();
})();
